import { post } from '../../../shared/utils/FetchV2.util';

export interface LinkingRewardAssignment {
	/**
	 * `false` = no hay premio para este usuario. NO es lo mismo que
	 * `rewardAmount: 0`: el 0 es el brazo de control, que SÍ está en el
	 * experimento y cuenta en el denominador. `eligible: false` es el kill
	 * switch del backend — el feature apagado en este ambiente.
	 */
	eligible: boolean;
	rewardAmount: number;
	experimentId: string;
	variationId: number;
	assignedAt: string;
}

/**
 * Registra la promesa: "a este usuario le toca $N si vincula".
 *
 * POST /api/v1/heru-sales-transaction-engine/credits/linking-reward/assign
 *
 * El user_id sale del JWT (FetchV2 siempre adjunta el token), no del body.
 *
 * EL MONTO QUE DEVUELVE MANDA SOBRE EL QUE MANDAMOS. La primera asignación de
 * un usuario congela su brazo, y a partir de ahí el backend responde SIEMPRE
 * ese, ignorando lo que le mandemos. Eso es a propósito: si mañana se recalibra
 * el experimento, un usuario a medio flujo no puede ver $50 en el banner y
 * cobrar $100 (ni al revés). Pintar la respuesta y no el valor local es lo que
 * hace que la promesa y el pago no puedan divergir.
 *
 * Es idempotente por user_id: llamarlo de más no reasigna ni cobra nada.
 */
export const assignLinkingReward = async (params: {
	experimentId: string;
	variationId: number;
	rewardAmount: number;
}): Promise<LinkingRewardAssignment> =>
	post<LinkingRewardAssignment>({
		service: 'salesTransactionEngine',
		endpoint: '/credits/linking-reward/assign',
		body: params,
		// El premio nunca debe interferir con la vinculación: sin esto, un 401
		// del endpoint dispararía el manejo global de sesión y podría sacar al
		// usuario del flujo por un banner.
		skipAccountError: true,
	});
